import { IEditLinkedTaskAction,IManageFlowAction, IRunFlowAction, IRunLinkedTaskAction } from '~src/spacesPlatform/models/actionNames';

export type ManageRunFlowTaskActions = IManageFlowAction | IEditLinkedTaskAction;

export type RunRunFlowTaskActions = IRunFlowAction | IRunLinkedTaskAction;

function isIManageFlowAction(action: ManageRunFlowTaskActions): action is IManageFlowAction {
  return (action as IManageFlowAction)?.manageFlow !== undefined;
}

function isIEditLinkedTaskAction(action: ManageRunFlowTaskActions): action is IEditLinkedTaskAction {
  return (action as IEditLinkedTaskAction)?.editLinkedTask !== undefined;
}

function isIRunFlowAction(action: IRunFlowAction | IRunLinkedTaskAction): action is IRunFlowAction {
  return (action as IRunFlowAction)?.runFlow !== undefined;
}

function isIRunLinkedTaskAction(action: IRunFlowAction | IRunLinkedTaskAction): action is IRunLinkedTaskAction {
  return (action as IRunLinkedTaskAction)?.runLinkedTask !== undefined;
}

export function userHasManageRunFlowTaskPermissions(actions: ManageRunFlowTaskActions): boolean {
 return !!(actions && (isIManageFlowAction(actions) && actions.manageFlow) ||
    (isIEditLinkedTaskAction(actions) && actions.editLinkedTask));
}

export function userHasRunRunFlowTaskPermissions(actions: RunRunFlowTaskActions): boolean {
  return !!(actions && (isIRunFlowAction(actions) && actions.runFlow) ||
    (isIRunLinkedTaskAction(actions) && actions.runLinkedTask));
}